export default {
  container: `
    max-width: 400px;
  `,
  alert: `
    margin-bottom: 10px;
  `,
};
